import UserSettings from './UserSettings.vue';

export default UserSettings;
